import { DateInput } from '@frontend/components/basic-forms';
import { Application } from '@frontend/functionality/types';
import { MessageDescriptor, useIntl } from 'react-intl';

import { useWizardModalScreenNavigation } from '../../wizard-modal-navigation.context';
import { useTransactionScheduling } from './transaction-scheduling.controller';

interface TransactionSchedulingMessages {
    title: MessageDescriptor;
    expectedDropOff: MessageDescriptor;
    expectedPickUp: MessageDescriptor;
}

const defaultMessages: TransactionSchedulingMessages = {
    title: {
        id: 'wizard.transaction-scheduling.title',
        defaultMessage: 'Schedule transaction'
    },
    expectedDropOff: {
        id: 'wizard.transaction-scheduling.expected-drop-off',
        defaultMessage: 'Expected drop-off'
    },
    expectedPickUp: {
        id: 'wizard.transaction-scheduling.expected-pick-up',
        defaultMessage: 'Expected pick-up'
    }
};

const messagesByApplication: Partial<Record<Application, Partial<TransactionSchedulingMessages>>> = {
    [Application.NIVALIZ]: {
        expectedDropOff: {
            id: 'wizard.transaction-scheduling.nivaliz.expected-drop-off',
            defaultMessage: 'Date of cremation'
        },
        expectedPickUp: {
            id: 'wizard.transaction-scheduling.nivaliz.expected-pick-up',
            defaultMessage: 'Date of urn collection'
        }
    }
};

export const TransactionScheduling = (props: { wizard_id: string }) => {
    const intl = useIntl();
    const viewProps = useTransactionScheduling(props);
    const messages = {
        ...defaultMessages,
        ...(viewProps.application ? messagesByApplication[viewProps.application] : undefined)
    };

    useWizardModalScreenNavigation({
        onContinue: viewProps.onSubmit,
        continueDisabled: viewProps.submitDisabled
    });

    return (
        <div
            id='transaction-scheduling'
            className='flex w-full flex-col gap-6'>
            <h2 className='text-foreground-default text-xl leading-normal font-semibold'>{intl.formatMessage(messages.title)}</h2>

            <div className='flex w-full flex-col gap-4'>
                <DateInput
                    id='transaction-scheduling-expected-drop-off'
                    value={viewProps.expectedDropOff}
                    onChange={viewProps.setExpectedDropOff}
                    label={intl.formatMessage(messages.expectedDropOff)}
                    submitted={false}
                    dateTime
                />
                <DateInput
                    id='transaction-scheduling-expected-pick-up'
                    value={viewProps.expectedPickUp}
                    onChange={viewProps.setExpectedPickUp}
                    label={intl.formatMessage(messages.expectedPickUp)}
                    errorMessage={intl.formatMessage({
                        id: 'wizard.transaction-scheduling.invalid-range',
                        defaultMessage: 'The expected pick-up cannot be before the expected drop-off.'
                    })}
                    valid={!viewProps.invalidRange}
                    submitted={false}
                    minDate={viewProps.expectedDropOff}
                    dateTime
                />
            </div>
        </div>
    );
};
